import { CookieAttributes } from 'js-cookie';

export const cookieName = process.env.VUE_APP_COOKIE_NAME || 'GWH_ADMIN';

export const cookieOptions: CookieAttributes = {
  expires: 7,
  // domain: process.env.VUE_APP_COOKIE_DOMAIN,
};
